import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Dialog, { withMobileDialog } from 'material-ui/Dialog';
import OfferActionForm from './OfferActionForm';

const OfferActionDialog = ({
  fullScreen,
  open,
  disabled,
  hideCancelButton,
  handleClose,
  request,
  title,
  dialogBody,
  enableMessage,
  submitText,
  acuantKyc,
}) => (
  <Fragment>
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <OfferActionForm
        disabled={disabled}
        hideCancelButton={hideCancelButton}
        request={request}
        title={title}
        dialogBody={dialogBody}
        handleClose={handleClose}
        enableMessage={enableMessage}
        submitText={submitText}
        acuantKyc={acuantKyc}
      />
    </Dialog>
  </Fragment>
);

OfferActionDialog.propTypes = {
  disabled: PropTypes.bool,
  hideCancelButton: PropTypes.bool,
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  request: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  dialogBody: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  enableMessage: PropTypes.bool.isRequired,
  submitText: PropTypes.string,
};

OfferActionDialog.defaultProps = {
  submitText: 'Submit',
  disabled: false,
  hideCancelButton: false,
};

export default withMobileDialog({
  breakpoint: 'xs',
})(OfferActionDialog);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferActionDialog.js